<router-outlet name="integration"></router-outlet>
